module.exports = __webpack_public_path__ + "static/media/ic_audio_white.fbe5ce0e.svg";